import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { FC } from "react";

type InfoBtnProps = {
    onClick: () => void
}

export const InfoBtn: FC<InfoBtnProps> = ({ onClick }) => {
    return (
        <FontAwesomeIcon icon={faInfoCircle} onClick={onClick} fontSize={15} />
    )
}